import { render, staticRenderFns } from "./BonusXLogin.vue?vue&type=template&id=c85a6342&scoped=true"
import script from "./BonusXLogin.vue?vue&type=script&lang=js"
export * from "./BonusXLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a6342",
  null
  
)

export default component.exports